<template>
  <div class="header-bg" :style="{ background: bgColor }">
    <div class="header">
      <NuxtLink class="logo-link" to="/">
        <img src="/images/logo.png" class="logo" />
      </NuxtLink>
      <NuxtLink to="/" :class="{ link: true, 'link-active': route.name === 'index' }">首页</NuxtLink>
      <a v-if="false" class="link">
        启动器下载
        <div v-if="launcherList.length" class="hover-container">
          <a
            v-for="item of launcherList"
            :key="item.engineTypeId"
            :href="joinFileUrl(item.filePath)"
            download
            class="launcher"
          >
            <div class="name">{{ item.engineTypeName }}</div>
            <SvgIcon class="icon" name="pc" />
            <div class="version">{{ item.version }}</div>
            <div class="download">启动器下载</div>
          </a>
        </div>
      </a>
      <NuxtLink
        to="/templateCenter"
        :class="{ link: true, 'link-active': ['templateCenter'].includes(route.name as string) }"
      >
        版本中心
      </NuxtLink>
      <a class="link">
        开发者中心
        <div class="hover-container" @blur="activeDocType = '0'" tabindex="0">
          <div class="doc-container">
            <div class="parent-category">
              <div
                v-for="parent of developerDocList"
                :key="parent.value"
                class="parent-name"
                :class="{ 'parent-name-active': activeDocType === parent.value }"
                tabindex="0"
                @mouseenter="activeDocType = parent.value"
              >
                <img :src="activeDocType === parent.value ? parent.activeIcon : parent.normalIcon" alt="" />
                <span style="margin-left: 8px">{{ parent.content }}</span>
                <img
                  class="arrow-icon"
                  :src="
                    activeDocType === parent.value
                      ? '/images/header/arrowRightActive.png'
                      : '/images/header/arrowRight.png'
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="child-category">
              <div
                v-for="childItem of childrenList"
                :key="childItem.content"
                class="child-name"
                @click="openDoc(childItem.value)"
              >
                {{ childItem.content }}
              </div>
            </div>
          </div>
        </div>
      </a>
      <a v-if="false" class="link">
        联系我们
        <div class="hover-container">
          <img src="/images/header/wechat-qr-code.png" class="qrcode" />
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, computed, ref, onMounted, onUnmounted } from '#imports'
import { joinFileUrl } from '@/utils'
import developerDocList from '@/assets/json/developerDocList.json'
import { getLauncherList, type Launcher } from '@/api'
import SvgIcon from '@/components/SvgIcon.vue'

const route = useRoute()
const scrollY = ref(0)
const bgColor = computed(() => {
  if (route.name !== 'index') {
    return '#221F53'
  }
  if (0 <= scrollY.value && scrollY.value <= 300) {
    return 'transparent'
  }
  if (300 <= scrollY.value && scrollY.value <= 800) {
    return 'rgba(0, 0, 0, 0.50)'
  }
  if (scrollY.value > 800) {
    return '#281F53'
  }
})

function scrollFn() {
  scrollY.value = window.scrollY
}

onMounted(() => {
  scrollFn()
  window.addEventListener('scroll', scrollFn)
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollFn)
})

type DeveloperDoc = (typeof developerDocList)[0]

const activeDocType = ref('0')
const childrenList = computed<DeveloperDoc['children']>(() => developerDocList[activeDocType.value].children)

function openDoc(url: string) {
  window.open(url)
}

const launcherList = ref<Launcher[]>([])

import.meta.client &&
  getLauncherList().then((res) => {
    launcherList.value = res
  })
</script>

<style lang="scss" scoped>
.header-bg {
  position: fixed;
  left: 0;
  z-index: 2;
  width: 100%;
  min-width: var(--pc-page-min-width);
  margin: 0 auto;

  .header {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 80px;
    padding-top: 24px;

    .logo-link {
      margin-right: auto;
    }

    .logo {
      height: 46px;
    }

    .link {
      color: #b8c2d6;
      position: relative;
      cursor: pointer;
      font-size: 18px;
      font-weight: 500;
      line-height: 56px;
      margin: 0 32px;

      .hover-container {
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
        position: absolute;
        top: 70px;
        left: -30px;
        border-radius: 12px;
        background: #292951;
        padding: 12px;
        display: flex;
        gap: 10px;
        z-index: 2;

        &:before {
          content: '';
          background-image: url('/images/header/hoverArrow.svg');
          background-size: cover;
          width: 20px;
          height: 9px;
          position: absolute;
          top: -8px;
          left: 65px;
        }

        .launcher {
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.08);
          width: 130px;
          height: 130px;
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          fill: rgba(255, 255, 255, 0.8);
          position: relative;

          .name {
            position: absolute;
            top: 4px;
            right: 4px;
            border-radius: 4px;
            background: rgba(255, 255, 255, 0.1);
            padding: 4px 6px;
            height: 20px;
            color: #ffffff;
            font-size: 11px;
            line-height: 12px;
          }

          .icon {
            display: block;
            margin: 30px auto 12px;
            width: 40px;
            height: 40px;
          }

          .version {
            font-size: 12px;
            font-weight: 500;
            line-height: 12px;
            margin-bottom: 4px;
          }

          .download {
            font-size: 13px;
            font-weight: 500;
            line-height: 13px;
          }

          &:hover {
            background: linear-gradient(134deg, #2d30ab 2.18%, #4a2a7a 97.84%);
            color: #ffffff;
            fill: #ffffff;

            .name {
              background: rgba(255, 255, 255, 0.8);
              color: #4d4cc2;
            }

            .version {
              color: rgba(255, 255, 255, 0.8);
            }
          }
        }
      }

      .qrcode {
        height: 130px;
        width: 130px;
      }

      &:hover {
        color: #ffffff;

        .hover-container {
          opacity: 1;
          visibility: visible;
        }
      }
    }

    .link-active {
      color: #ffffff;
    }
  }
}

.doc-container {
  display: flex;
  height: 330px;

  .parent-category {
    display: flex;
    flex-direction: column;

    .parent-name {
      border-radius: 6px;
      width: 180px;
      color: #8c95b8;
      font-size: 16px;
      height: 48px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      position: relative;

      .arrow-icon {
        width: 16px;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .parent-name-active {
      background: #35356e;
      color: #fff;
    }
  }

  .child-category {
    overflow-y: auto;
    overflow-x: hidden;
    padding-left: 16px;
    border-left: 1px solid #333950;
    margin-left: 16px;
    /* 滚动条整体样式 */
    &::-webkit-scrollbar {
      display: inline;
      width: 4px;
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      background: #272b3a;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      background: #343a4d;
      border-radius: 10px;
    }

    /* 滚动条滑块悬停状态 */
    &::-webkit-scrollbar-thumb:hover {
      background: #343a4d;
    }

    &::-webkit-scrollbar-button {
      display: none;
    }

    .child-name {
      width: 140px;
      height: 46px;
      color: #8c95b8;
      font-size: 16px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
    }

    .child-name:hover {
      background: #35356e;
      color: #fff;
    }
  }
}
</style>
